// extracted by mini-css-extract-plugin
module.exports = {"ImageControl":"ImageControl_ImageControl__1WM7C"};